<div class="input-otp-code">
  <label [innerHTML]="label"></label>
  <div class="input-otp-code__container form-group">
    <ng-container *ngIf="!isLoading">
      <div
        class="input-otp-code__container__box"
        *ngFor="let input of inputs; let i = index"
        [ngClass]="{
          filled: values[i] !== null && values[i] !== undefined && values[i] !== '',
          error: !!error
        }"
      >
        <input
          #fieldElement
          id="field-{{ i }}"
          class="form-control code"
          [value]="values[i]"
          [attr.maxlength]="1"
          (input)="onInput($event, i)"
          (paste)="(false)"
          (keydown)="onKeydown($event, i)"
          type="number"
          inputmode="numeric"
        />
      </div>
    </ng-container>
    <ng-container *ngIf="isLoading">
      <div class="input-otp-code__container__box" *ngFor="let input of inputs">
        <layout-skeleton [data]="skeletonInfo"></layout-skeleton>
      </div>
    </ng-container>
  </div>
  <div class="input-otp-code__timer">
    <p>{{ time | timer }}</p>
    <u [ngClass]="{ blocked: time > 0 }" (click)="onResendCode()">Solicitar nuevo código</u>
  </div>
  <div class="input-otp-code__error" [ngClass]="{ show: !!error }">
    <p>
      El código SMS que ingresaste es incorrecto o expiró.<br />
      <span>Por favor, solicita uno nuevo.</span>
    </p>
  </div>
  <ng-container *ngIf="!error">
    <button class="input-otp-code__popup" (click)="onOpenErrorStillNotReceivingCode()">
      <u>¿Aún no recibes el código SMS?</u>
    </button>
  </ng-container>
</div>
